export { Display } from './Display';
export type { DisplayProps } from './Display';

export { Headline } from './Headline';
export type { HeadlineProps } from './Headline';

export { Title } from './Title';
export type { TitleProps } from './Title';

export { Subtitle } from './Subtitle';
export type { SubtitleProps } from './Subtitle';

export { Text } from './Text';
export type { TextProps } from './Text';

export { Caption } from './Caption';
export type { CaptionProps } from './Caption';

export type { DsTextColor } from './typographyTextColor';
